export const defaultPalette: string[] = [
  '#FFCB1F',
  '#FF903E',
  '#F45050',
  '#DA4D7C',
  '#A373FD',
  '#4C61E5',
  '#49A9D4',
  '#4EA385',
  '#63B84E',
  '#695A50',
  '#A0A0A0',
];
